import { createContext, useContext } from 'react';

export type CategoryFlowActionsContextValue = {
  canManageCategories: boolean;
  removingChildId: number | null;
  attachingChildId: number | null;
  onRemoveParentLink: (childCategoryId: number) => void;
};

export const CategoryFlowActionsContext = createContext<CategoryFlowActionsContextValue | null>(
  null
);

/** Accède aux actions du canvas (détachement, états de chargement). */
export function useCategoryFlowActions() {
  const context = useContext(CategoryFlowActionsContext);
  if (!context) {
    throw new Error('useCategoryFlowActions must be used within CategoryFlowActionsContext');
  }
  return context;
}
